var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66667 11.7652L3 7.88259L9.66667 4V7.21011H15C16.9114 7.21011 18.4249 8.1802 19.4409 9.48457C20.4485 10.7781 21 12.4371 21 13.9349C21 16.94 18.7549 19.9873 15 19.9873L5.57143 20V18.655L15 18.6423C17.9117 18.6423 19.6667 16.3098 19.6667 13.9349C19.6667 12.7429 19.2182 11.3756 18.3925 10.3155C17.5751 9.26619 16.422 8.55507 15 8.55507H9.66667V11.7652Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.3fc21a47f5d0df2b1915057fad6a2937.svg";
export { ForwardRef as ReactComponent };